
import React, { useState } from 'react';
import { CycleData, HormoneType } from '@/utils/cycle-tracking';
import { HormoneChartCard } from './hormone-test/HormoneChartCard';

interface HormoneTestPlaceholderProps {
  cycleData: CycleData | null;
}

const HormoneTestPlaceholder: React.FC<HormoneTestPlaceholderProps> = ({ cycleData }) => {
  const [selectedHormones, setSelectedHormones] = useState<HormoneType[]>(['estrogen', 'progesterone']);
  const [showPhases, setShowPhases] = useState<boolean>(true); // Default to true, toggle removed
  
  const toggleHormone = (hormone: HormoneType) => {
    setSelectedHormones(prevSelected => {
      if (prevSelected.includes(hormone)) {
        return prevSelected.filter(h => h !== hormone);
      } else {
        return [...prevSelected, hormone];
      }
    });
  };
  
  return (
    <div className="w-full">
      <HormoneChartCard 
        cycleData={cycleData} 
        selectedHormones={selectedHormones}
        toggleHormone={toggleHormone}
        showPhases={showPhases}
        setShowPhases={setShowPhases}
      />
    </div>
  );
};

export default HormoneTestPlaceholder;
